import { useEffect } from 'react';

const handleBeforeUnload = (event: BeforeUnloadEvent):void => {
  event.preventDefault();
  event.returnValue = 'If you exit this page without saving, your changes will be lost.';
};

const useExitPrompt = (enabled: boolean): void => {
  useEffect(() => {
    if (enabled) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [enabled]);
};

export default useExitPrompt;
